import { ErrorCodes } from "./types";
import { CustomError, allowedParamsName } from "./utils";
export function ensureIncludePresignedLinksTrue(requestParams) {
    return requestParams.includePresignedLinks === undefined
        ? { ...requestParams, includePresignedLinks: true }
        : requestParams;
}
export function validateAndExtractQueryParam(requestParams) {
    const queryParams = new URLSearchParams();
    if (requestParams.assetReferenceType == null)
        throw new CustomError('assetReferenceType is required', ErrorCodes.badRequest);
    if (!requestParams.rxId?.trim())
        throw new CustomError('rxId is required', ErrorCodes.badRequest);
    const params = ensureIncludePresignedLinksTrue(requestParams);
    Object.entries(params).forEach(([key, value]) => {
        if (!allowedParamsName.includes(key)) {
            throw new CustomError(`${key} is an invalid property for this request`, ErrorCodes.badRequest);
        }
        if (value == null)
            return;
        if (Array.isArray(value)) {
            value.forEach((item) => { if (item !== null && item !== undefined)
                queryParams.append(key, String(item)); });
            return;
        }
        queryParams.append(key, String(value));
    });
    return queryParams;
}
export function ensureBearer(assetBffAuthToken) {
    return assetBffAuthToken.includes("Bearer") || assetBffAuthToken.includes("bearer") ? assetBffAuthToken : `Bearer ${assetBffAuthToken}`;
}
export function pollingDelay(pollingIntervalMs) {
    return new Promise(resolve => setTimeout(resolve, pollingIntervalMs));
}
//# sourceMappingURL=helpers.js.map